import React from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import './InputSelect.css';
import PropTypes from 'prop-types';
import getLabel from '../../translations/messages';

const handleChange = (props, v) => {
  const selected = v ? v : { value: null };

  props.handleChange({
    target: {
      name: props.name,
      value: selected.value,
    },
  });
};

const InputSelect = (props, context) => {
  const options = props.options.map(o => ({
                    value: props.translateValue ? getLabel(context.locale, o.value) : o.value,
                    label: getLabel(context.locale, o.label),
                  }));

  return (
    <div className="InputSelect" style={props.style} name={props.name + '-component'}>
      <div className="inputLabel">
        <span>{getLabel(context.locale, props.label)}</span>
        {props.required ? <span className="required">*</span> : ''}
      </div>
      <Select
        name={props.name}
        value={props.value}
        onChange={(selected) => handleChange(props, selected)}
        options={options}
        noResultsText={getLabel(context.locale, 'general.noResults')}
        placeholder={getLabel(context.locale, 'general.valueChoosing')}
      />
    </div>
  );
};

InputSelect.contextTypes = {
  locale: PropTypes.string,
};

export default InputSelect;



// WEBPACK FOOTER //
// ./src/main/components/input/InputSelect.js